<template>
  <div class="leaderList">
    <!-- 头部信息 -->
    <div class="header_box">
      <!-- 头部搜索框 -->
      <div class="search">
        <input type="text" class="search_key" :placeholder="formData.hold" v-model="formData.inputParams" />
        <span class="search_btn" @click="startSearch">查询</span>
        <img src="../../../../../assets/image/search.png" class="search_img" />
      </div>
      <!-- 筛选功能 -->
      <div class="search_query">
        <div class="item" @click="showCity">
          <span class="city">{{formData.placeName}}</span>
          <img src="../../../../../assets/image/jiantou.png" class="jian" />
        </div>
        <div class="item" @click="showType">
          <span class="city">{{formData.typePickerValue}}</span>
          <img src="../../../../../assets/image/jiantou.png" class="jian" />
        </div>
        <div class="item" @click="showTime">
          <span class="city">{{formData.datePickerValue}}</span>
          <img src="../../../../../assets/image/jiantou.png" class="jian" />
        </div>
      </div>
    </div>
    <van-list
      ref="vanList"
      v-model="loading"
      :finished="finished"
      :finished-text="finishedText"
      :immediate-check="false"
      @load="onLoad"
      class="wrapper"
    >
      <div class="reject" v-for="(item,index) in proList" :key="index" @click="goDetail(item)">
        <div class="reject_item">
          <div class="item_content">
            <div class="title">
              <p class="title_text">{{item.defendantName}}</p>
              <p
                v-if="item.urgencyDegree"
                class="title_tag1"
                :class="sstt[item.urgencyDegree == '' ? '': Number(item.urgencyDegree-7)]"
              >{{sttText[item.urgencyDegree == '' ? '': Number(item.urgencyDegree-7)]}}</p>
            </div>
            <div class="wrappers">
              <p>所属区域:</p>
              <p>{{item.belongMechanismName}}</p>
            </div>
            <div class="info">
              <span>投诉人:</span>
              <span>{{item.complainName}}</span>
            </div>
            <div class="info">
              <span>投诉时间:</span>
              <span>{{item.complainTime|filt()}}</span>
            </div>
            <div class="info">
              <span>投诉单号:</span>
              <span>{{item.mainComplainNumber}}</span>
            </div>
            <div class="info" v-show="item.handleTimeLimit">
              <span>时长时限:</span>
              <span>{{item.handleTime|filt3()}} | {{item.handleTimeLimit|filt4()}}</span>
            </div>
          </div>
          <div class="line"></div>
          <div class="status">
            <p>{{item.statueName}}</p>
            <p>
                <span>查看详情</span>
                <span>
                    <img src="../../../../../assets/image/right.png" alt="">
                </span>
            </p>
          </div>
        </div>
      </div>
    </van-list>
    <isNoInfo :isNolist="isNolist"></isNoInfo>
    <common-picker v-if="pickerList.cityList.length" ref="commonPicker1" :typeList="pickerList.cityList" :cols="pickerList.col" @getTypeValue="getCityValue"></common-picker>
    <common-picker ref="commonPicker2" :typeList="pickerList.channerList" :cols="1" @getTypeValue="getTypeValue"></common-picker>
    <common-picker ref="commonPicker3" :typeList="pickerList.dataList" :cols="3" @getTypeValue="getValue" :isShowAbountButton="true"  @showRangTime="showRangTime"></common-picker>
    <!-- 时间范围选择 -->
    <rangTime ref="rangeTime" @getCurrentTime="getCurrentTime" :allowSameDay="true"></rangTime>
  </div>
</template>
<script>
    import util from '../../../../../utils/common';
    import moment from 'moment';
    import { formateYear, timeType, channer, complaintTime } from '../../../../../utils/configJson';
    import commonPicker from '../../../../../components/base/commonPicker';
    import isNoInfo from '../../../../../components/isNoInfo.vue';
    import api from '../../../../../service/modules/complaintApis'
    import rangTime from '../../../../../components/rangTime1';
    
    export default {
        components: {
            commonPicker,
            isNoInfo,
            rangTime
        },
        data () {
            return {
                formData:{
                  place:'',
                  placeName:'云南省',
                  pageSize:10,
                  curPage:1,
                  inputParams:'',
                  startDate:'',
                  endDate:'',
                  complainChannel:'',//渠道
                  complainClassify:'',//分类
                  datePickerValue:'筛选时间',
                  typePickerValue:'投诉渠道',
                  hold:'投诉单号/投诉人姓名/被投诉对象名称',
                },
                proList: [], // 列表数据
                finished: false,
                finishedText: '没有更多',
                isNolist: false, // 没有内容的状态
                isload: true, // 底部加载中的状态
                loading: true,
                sstt: ['ss1', 'ss2', 'ss3'],
                sttText: ['一般', '较重', '严重'],
                typeList: [],
                pickerList:{
                  cityList:[],
                  channerList:[],
                  dataList:[],
                  col:1,//固定几行
                },
                state:true,
                userInfo:util.getJsonLocal('userInfoComplaint')
            };
        },
        computed: {
            deptInfo () {
                console.log('this.$store.state.complaint.deptInfo:', this.$store.state.complaint.deptInfo);
                return this.$store.state.complaint.deptInfo;
            }
        },
        created () {
            this.initData();
        },
        mounted () {
        },
        methods: {
            initData(){
              this.pickerList.channerList=this.$store.state.complaint.channerList;
              if (!this.pickerList.channerList.length) {
                this.$store.dispatch('complaint/channerList').then(data => {
                  this.pickerList.channerList = this.$store.state.complaint.channerList;
                })
              }
              this.pickerList.dataList=complaintTime()
              this.formData=Object.assign({},this.formData,this.$route.query);
              this.getAllCity();
              this.getList();
            },
            getCurrentTime(value){
              if (value) {
                    this.formData.startDate = value[0].split(' ')[0] + ' 00:00:00';
                    this.formData.endDate = value[1].split(' ')[0] + ' 23:59:59';
                    this.formData.datePickerValue = value[0].split(' ')[0] + ' 00:00:00'+'-'+value[1].split(' ')[0] + ' 23:59:59';
                    this.ishowRangeTime = false;
                    this.proList=[];
                    this.formData.curPage=1;
                    this.getList();
                } else {
                    this.ishowRangeTime = false;
                }
            },
            goDetail (value) {
                this.$router.push({
                    name: 'workListDetails',
                    query: {
                          complainNumber:value.complainNumber,
                          mainComplainNumber:value.mainComplainNumber,
                    }
                });
                util.setJsonLocal('item', value);
            },
            showRangTime(){
              this.$refs.rangeTime.showTime();
            },
            showCity () {
                this.$refs.commonPicker1.showPicker();
            },
            showType () {
                this.$refs.commonPicker2.showPicker();
            },
            showTime () {
                this.$refs.commonPicker3.showPicker();
            },
            getValue (value) {
                if (value[1].key === 'year') {
                    this.formData.datePickerValue = value[0].value + '年';
                    this.formData.startDate = value[0].value + '-' + value[1].value1 + ' ' + '00:00:00';
                    this.formData.endDate = value[0].value + '-' + value[1].value2 + ' ' + '23:59:59';
                } else if (value[1].key === 'quarter') {
                    this.formData.datePickerValue = value[0].value + value[2].text;
                    this.formData.startDate = value[0].value + '-' + value[2].value1 + ' ' + '00:00:00';
                    this.formData.endDate = value[0].value + '-' + value[2].value2 + ' ' + '23:59:59';
                } else if (value[1].key === 'moutn') {
                    this.formData.datePickerValue = value[0].value + '年' + value[2].value1 + '月';
                    const d = new Date(value[0].value, value[2].value1, 0)// 获取当月的天数
                    this.formData.startDate = value[0].value + '-' + value[2].value1 + '-01' + ' ' + '00:00:00';
                    this.formData.endDate = value[0].value + '-' + value[2].value1 + '-' + d.getDate() + ' ' + '23:59:59';
                }
                this.formData.curPage=1;
                this.proList = [];
                this.getList();
            },
            getTypeValue (value) {
                this.formData.typePickerValue=value[0].text;
                this.formData.complainChannel=value[0].value;
                this.formData.curPage=1;
                this.proList = [];
                this.getList();
            },
            getCityValue (value) {
                console.log(66, value);
                if (value.length > 1 && value[1].label !== '全部') {
                    this.formData.placeName = value[0].label + '-' + value[1].label;
                    this.formData.place = value[1].areaId;
                } else {
                    this.formData.placeName = value[0].label;
                    this.formData.place = value[0].areaId;
                }
                this.formData.curPage=1;
                this.proList = [];
                this.getList();
            },
            getTimeValue (value) {
                this.md.datePickerValue = value;
            },
            // 初始化区域数据列表
            getAllCity () {
                // 获取所有的市
                const params = {
                    data: {
                        cityCode: this.deptInfo.txId
                    }
                };
                this.$store.dispatch('complaint/region', params).then(data => {
                    // 当前用户所属城市下级城市列表
                    if (this.deptInfo.areaLevel === '1') {
                        this.pickerList.col = 2;
                    } else if (this.deptInfo.areaLevel === '2') { // 省级权限
                        this.pickerList.col = 2;
                    } else { // 区县权限
                        this.pickerList.col = 1;
                    }
                    this.pickerList.cityList = [data];
                    console.log('this.pickerList.cityList:', this.pickerList.cityList);
                    this.$nextTick(() => {
                        this.$refs.commonPicker1 && this.$refs.commonPicker1._initFresh();
                    })
                });
            },
            // 查询
            startSearch () {
                  this.proList=[];
                  this.formData.curPage=1;
                  // this.formData.startDate='';
                  // this.formData.endDate='';
                if (this.formData.inputParams.trim().length === 0) {
                  this.getList();
                } else {
                  this.getList();
                }
            },
            queryDataCallback(data) {
              if(data.ret==0){
                  if(data.data.list.length>0){
                     this.loading = false;
                     if(this.state){
                       this.proList=data.data.list;
                     }else{
                       this.proList = this.proList.concat(data.data.list);
                     }
                  }else{
                    this.finished = true;
                    this.loading = false;
                    if(this.state){
                      this.finishedText='';
                      this.isNolist=true;
                    }
                  }
                }
            },
            getList () {
                let params=JSON.parse(JSON.stringify(this.formData));
                var data;
                let delectProps;
                let searchList=['allList','timeoutList','notAcceptList','splitList','uncompletedList','caseList','auditList','superviseList','returnVisitList','waitAcceptCase','waitDealCase'];
                delectProps = searchList.indexOf(params.type) > -1 ? ['placeName','datePickerValue','typePickerValue','hold'] : ['placeName','datePickerValue','typePickerValue','hold','type'];
                delectProps.map(key=>{
                  delete params[key]
                })
                params = {
                  data: params
                }
                console.log('测试'+this.formData.type)
                let value=this.formData.type;
                switch(value){
                  case 'notHandleComplainList'://待处理
                       if(this.userInfo.userInfo.orgType.indexOf('tszhzx')>-1){//指挥中心
                          api.worker.notHandleComplainList(params).then(data => this.queryDataCallback(data));
                       }else if(this.userInfo.userInfo.orgType.indexOf('wbtj')>-1||this.userInfo.userInfo.orgType.indexOf('company')>-1){//部门
                          api.worker.listDepEnterpriseAwaitHandle(params).then(data => this.queryDataCallback(data));
                       }
                       break;
                  case 'notAcceptComplainList'://待响应
                       api.worker.notAcceptComplainList(params).then(data => this.queryDataCallback(data));
                       break;     
                  case 'superviseToAcceptList'://督办待处理
                       api.worker.listSuperviseToAccept(params).then(data => this.queryDataCallback(data));
                       break;
                  case 'awaitReportlist'://上报待审核
                       api.worker.listAwaitReport(params).then(data => this.queryDataCallback(data));
                       break;
                  case 'applySplitOrderList'://拆弹待审核
                       api.worker.queryVerifyList(params).then(data => this.queryDataCallback(data));
                       break;
                  case 'waitAcceptCase'://待立案
                       api.worker.caseList(params).then(data => this.queryDataCallback(data));
                       break;
                  case 'awaitPendingList'://部门待处理
                       api.worker.listDepEnterpriseAwaitHandle(params).then(data => this.queryDataCallback(data));
                       break;     
                  case 'waitDealCase'://转诉案待处理
                       api.worker.caseList(params).then(data => this.queryDataCallback(data));
                       break;
                  case 'applyVerifyList'://部门审核列表
                      //  api.worker.queryApplyVerifyList(params).then(data => this.queryDataCallback(data));
                      api.worker.queryApplyVerifyList(params).then(data => this.queryDataCallback(data));
                       break;
                  case 'feedBackList'://部门审核列表
                      //  api.worker.queryApplyVerifyList(params).then(data => this.queryDataCallback(data));
                      api.worker.queryApplyVerifyList(params).then(data => this.queryDataCallback(data));
                       break;                  
                  default:
                      if (['allList','timeoutList','notAcceptList','splitList','uncompletedList','caseList','auditList','superviseList','returnVisitList'].indexOf(this.formData.type) > -1) {
                        api.worker.queryList(params).then(data => this.queryDataCallback(data));
                      }
                      break;                        
                }
            },
            onLoad () {
                this.formData.curPage++;
                this.state=false;
                this.getList(this.state);
            }
        },
        filters: {
            filt (value) {
                return moment(value).format('YYYY-MM-DD HH:mm:ss');
            },
            filt1 (value) {
                var config = util.getJsonLocal('configList').PRODUCT_TYPE;
                let name = '';
                config.map((item, index) => {
                    if (item.code === value) {
                        name = item.name;
                    }
                });
                return name;
            },
            filt2 (value) {
                var config = util.getJsonLocal('configList').WORK_ORDER_FLOW;
                let name = '';
                config.map((item, index) => {
                    if (item.code === value) {
                        name = item.name;
                    }
                });
                return name;
            },
            // 时长计算
            filt3 (value) {
                // let duration = str;

                // let zero = function (times) {
                //     return times;
                // };
                // let hour = zero(Math.floor(duration / 3600));
                // let minutes = zero(Math.ceil((duration / 60) % 60));
                // let times = '';
                // if (hour > 0) {
                //     times += hour + '小时';
                // }
                // times += minutes + '分钟';
                var theTime = parseInt(value);// 秒
                var middle= 0;// 分
                var hour= 0;// 小时

                if(theTime > 60) {
                    middle= parseInt(theTime/60);
                    theTime = parseInt(theTime%60);
                    if(middle> 60) {
                        hour= parseInt(middle/60);
                        middle= parseInt(middle%60);
                    }
                }
                var result = ""+parseInt(theTime)+"秒";
                if(middle > 0) {
                    result = ""+parseInt(middle)+"分"+result;
                }
                if(hour> 0) {
                    result = ""+parseInt(hour)+"小时"+result;
                }
                return result;
            },
            // 计算时限
            filt4 (str) {
                let duration = str;
                let zero = function (times) {
                    return times;
                };
                let hour = zero(Math.floor(duration / 3600));
                let minutes = zero(Math.ceil((duration / 60) % 60));
                let times = '';
                if (hour > 0) {
                    times += hour + 'h';
                }
                if (minutes > 0) {
                    times += minutes + 'm';
                }
                return times;
            }
        }
    };
</script>
<style scoped lang="less">
.leaderList {
  width: 100%;
  height: 100%;
  background-color: #fbfbfb;
  .header_box {
    width: 100%;
    position: fixed;
    left: 0;
    top: 0;
    z-index: 2;
    background-color: #fff;
    .search {
      width: 100%;
      position: relative;
      margin-top: 10px;
      .search_key {
        width: 297px;
        height: 36px;
        background: #f8f8f8;
        border-radius: 18px;
        margin-left: 15px;
        font-size: 13px !important;
        padding-left: 39px;
        box-sizing: border-box;
        border: 0;
        outline: none;
        line-height: 36px;
      }
      .search_btn {
        font-size: 14px;
        margin-left: 16px;
      }
      .search_img {
        width: 15px;
        height: 14px;
        position: absolute;
        left: 30px;
        top: 11px;
      }
    }
    .search_query {
      width: 100%;
      height: 42px;
      display: flex;
      display: -webkit-flex;
      flex-direction: row;
      -webkit-flex-direction: row;
      border-bottom: 1px solid #eee;
      .item {
        flex: 1;
        text-align: center;
        line-height: 42px;
        .city {
          display: inline-block;
          vertical-align: middle;
          font-size: 12px;
          color: #666;
          max-width: 110px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
        .jian {
          width: 6px;
          height: 4px;
          display: inline-block;
          vertical-align: middle;
        }
      }
    }
  }
  .wrapper {
    width: 100%;
    padding-top: 88px;
    .reject {
      width: 100%;
      .reject_item {
        margin: 20px 15px 0 15px;
        box-sizing: border-box;
        background-color: #fff;
        box-shadow: 0px 5px 20px 5px rgba(0, 0, 0, 0.04);
        .item_content {
          padding: 16px 16px 0 16px;
          .info {
            margin-top: 12px;
            span:nth-child(1) {
              display: inline-block;
              width: 65px;
              font-size: 14px;
              color: #777;
            }
            span:nth-child(2) {
              display: inline-block;
              font-size: 14px;
              color: #777;
            }
          }
          .wrappers {
              margin-top: 12px;
              display: flex;
              p {
                  font-size: 14px;
                  color: #777;
              }
              p:nth-child(1) {
                  width: 65px;
                  font-size: 14px;
                  color: #777;
                  line-height: 16px;
              }
              p:nth-child(2) {
                  font-size: 14px;
                  color: #777;
                  width: 79%;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                  line-height: 16px;
              }
              .info_line {
                  content:'';
                  display: inline-block;
                  background: #666666;
                  margin: -8px 5px;
                  width:1px;
                  height: 16px;
                  -webkit-transform:scaleY(0.5);
                  transform:scaleY(0.5);
                  -webkit-transform-origin: 0 0;
                  transform-origin: 0 0;
              }
          }
        }
        .line {
          width: 100%;
          height: 1px;
          margin-top: 25px;
          position: relative;
          border: none;
        }
        .line:after {
          content:'';
          position:absolute;
          bottom: 0;
          left: 0;
          background: #eeeeee;
          width:100%;
          height: 1px;
          -webkit-transform:scaleY(0.5);
          transform:scaleY(0.5);
          -webkit-transform-origin: 0 0;
          transform-origin: 0 0;
        }
        .status {
          width: 100%;
          padding: 20px 16px;
          font-size: 14px;
          color: #333;
          display: flex;
          justify-content: space-between;
          p:nth-child(2) {
              display: flex;
              align-items: center;
              span {
                  color: #999999;
                  font-size: 12px;
              }
          }
          p>span>img {
              width: 4px;
              height: 7px;
              margin-left: 4px;
              margin-top:-3px;
          }
        }
      }
      .title {
        display: flex;
        justify-content: space-between;
        .title_text {
          font-size: 16px;
          font-weight: 700;
          color: #2a2a2a;
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
          line-height: 20px;

        }
        .title_tag {
          width: 36px;
          height: 18px;
          font-size: 10px;
          color: #ffffff;
          border-radius: 9px;
          text-align: center;
          line-height: 18px;
        }
        .ss1 {
          background: #118bf5;
        }
        .ss2 {
          background: #ffa509;
        }
        .ss3 {
          background: #f75c32;
        }
      }
      .space {
        width: 100%;
        height: 4px;
        background-color: #eee;
      }
    }
  }
}
</style>
